import axios from 'axios';

// const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5292/'; // Replace with your actual backend URL
const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://ilmsapi.saamitradestar.com/';//localhost:5292/'; // Replace with your actual backend URL

// Create an Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Example usage to get data
// export const getData = async (endpoint, config = {}) => {
//   try {
//     const response = await api.get(endpoint, config);
//     return response.data;
//   } catch (error) {
//     console.error('API GET call failed:', error);
//     throw error;
//   }
// };

// // Example usage to post data
// export const postData = async (endpoint, data, config = {}) => {
//   try {
//     const response = await api.post(endpoint, data, config);
//     return response.data;
//   } catch (error) {
//     console.error('API POST call failed:', error);
//     throw error;
//   }
// };

// Export the default axios instance for custom requests
export default api;
